class AuthenticationFailedError extends Error {
  constructor(message, ...args) {
    const msg = 'failed to authenticate';

    super(message || msg, ...args);
    this.name = 'AuthenticationFailedError';

    Error.captureStackTrace(this, AuthenticationFailedError);
  }
}

export default AuthenticationFailedError;
